import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";
import * as layers from "@styles/emotion-styles/layers";

const navHeight = "4rem";

export const stickyMobileNav = css`
  height: ${navHeight};

  @media only screen and (min-width: ${dimensions.desktop}) {
    display: none;
  }
`;

export const stickyMobileNavContainer = (theme: Theme) => css`
  background-color: ${theme.surface.level1};
  border-bottom: ${theme.separator.base};
  width: 100%;
  height: ${navHeight};
  position: fixed;
  z-index: ${layers.indexStickyNavBar};
`;

export const mobileNavMain = css`
  height: ${navHeight};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
`;

export const homeLink = css`
  display: flex;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

export const sidebarToggleContainer = css`
  flex-shrink: 0;
  padding-right: 0.75rem;
`;

export const navLogo = css`
  height: 1.8125rem;
`;

export const homeButton = css`
  margin-left: 0.75rem;
  display: flex;
`;
